"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SqlType = /** @class */ (function () {
    function SqlType() {
    }
    SqlType.SQLTYPE_ERROR = -1; /// Error durante el parsing del SQL
    SqlType.SQLTYPE_UNKNOWN = 0; /// Aún no se ha parseado o se trata de una operación desconocida
    SqlType.SQLTYPE_INSERT = 1; /// Sentencia INSERT
    SqlType.SQLTYPE_DELETE = 2; /// Sentencia DELETE
    SqlType.SQLTYPE_UPDATE = 3; /// Sentencia UPDATE
    SqlType.SQLTYPE_SELECT = 4; /// Sentencia SELECT
    return SqlType;
}());
exports.default = SqlType;

//# sourceMappingURL=SqlType.js.map
